module.exports = __webpack_public_path__ + "img/link-on-premise-bg_375.5a3aecf.jpg";